import { writable } from "svelte/store";

export const ajaxIsCalling = writable(false);